import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import type { DrawerProps } from '@mui/material';
import { Box, Divider, Drawer, IconButton, Typography } from '@mui/material';

import useSurveyLogoAndName from 'src/hooks/useSurveyLogoAndName';
import ButtonList from 'src/components/app/Header/components/DrawerNavigation/components/ButtonList';
import MetaNavigation from 'src/components/app/Header/components/MetaNavigation';
import PreviousVersionBanner from 'src/components/app/Header/components/PreviousVersionBanner';

import { styles } from './index.styles';

interface DrawerNavigationProps extends DrawerProps {
  hideProjectLogo?: boolean;
  hideTabNavigation?: boolean;
  hidePreviousVersionBanner?: boolean;
  hideSurveySettings?: boolean;
}

const DrawerNavigation: FC<DrawerNavigationProps> = ({
  hideProjectLogo,
  hideTabNavigation,
  hidePreviousVersionBanner,
  hideSurveySettings,
}) => {
  const { t } = useTranslation('common');
  const [isOpen, setIsOpen] = useState(false);
  const { surveyLogo, surveyName } = useSurveyLogoAndName();

  return (
    <>
      <IconButton onClick={() => setIsOpen(!isOpen)}>
        <MenuRoundedIcon fontSize="large" />
      </IconButton>
      <Drawer
        anchor="left"
        className="DrawerNavigation-root"
        onClose={() => setIsOpen(false)}
        open={isOpen}
        sx={styles.drawerNavigation}
      >
        <Box>
          <IconButton onClick={() => setIsOpen(false)}>
            <CloseRoundedIcon fontSize="large" />
          </IconButton>
        </Box>
        {!hidePreviousVersionBanner && <PreviousVersionBanner />}

        {!hideProjectLogo && (
          <Box className="DrawerNavigation-header" sx={styles.header}>
            <Box sx={styles.surveyLogo}>
              {surveyLogo && (
                <img alt={t('appLogo')} src={surveyLogo} height="100%" />
              )}
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 600 }}>{surveyName}</Typography>
            </Box>
          </Box>
        )}

        {!hideTabNavigation && <ButtonList setIsOpen={setIsOpen} />}

        <Divider sx={{ mt: 'auto' }} />

        <MetaNavigation hideSurveySettings={hideSurveySettings} />
      </Drawer>
    </>
  );
};

export default DrawerNavigation;
